module.exports = __webpack_public_path__ + "static/media/Group-679.317480f0.png";